// Quick add for products with options: a card's "Choose" button opens a small dialog with the product's
// options (fetched from sections/fg-quick-add.liquid). Adding closes it; fg-cart.js then opens the bag.
// Without JS the card's title still links to the product page.
(() => {
  if (!window.fetch || typeof HTMLDialogElement !== 'function') return;
  let dialog;
  let opener;

  const build = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'fg-quick';
    dialog.setAttribute('aria-labelledby', 'FgQuickTitle');
    dialog.innerHTML = `<button type="button" class="fg-quick__close" data-fg-quick-close aria-label="${document.documentElement.lang === 'es' ? 'Cerrar' : 'Close'}">×</button><div data-fg-quick-slot></div>`;
    document.body.append(dialog);
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('[data-fg-quick-close]')) close();
    });
    dialog.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    dialog.addEventListener('change', onChange);
    dialog.addEventListener('submit', () => setTimeout(close, 50));
  };

  const close = () => {
    dialog.classList.remove('is-open');
    setTimeout(() => { dialog.close(); opener?.focus(); }, 250);
  };

  const onChange = (event) => {
    if (!event.target.matches('[data-fg-q-option]')) return;
    const form = dialog.querySelector('[data-fg-quick-form]');
    const variants = JSON.parse(form.querySelector('[data-fg-quick-variants]').textContent);
    const chosen = [...form.querySelectorAll('[data-fg-q-option]:checked')].map((i) => i.value);
    const variant = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    const btn = form.querySelector('[data-fg-quick-add]');
    if (!variant) { btn.disabled = true; btn.textContent = btn.dataset.soldoutLabel; return; }
    form.querySelector('[data-fg-quick-id]').value = variant.id;
    btn.disabled = !variant.available;
    btn.textContent = variant.available ? btn.dataset.addLabel : btn.dataset.soldoutLabel;
    const price = dialog.querySelector('[data-fg-quick-price]');
    if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(variant.price / 100);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-fg-quick]');
    if (!button) return;
    event.preventDefault();
    opener = button;
    if (!dialog) build();
    button.setAttribute('aria-busy', 'true');
    try {
      const url = `${button.dataset.fgQuick}${button.dataset.fgQuick.includes('?') ? '&' : '?'}section_id=fg-quick-add`;
      const html = await fetch(url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const body = doc.querySelector('[data-fg-quick-body]');
      if (!body) throw new Error('no body');
      dialog.querySelector('[data-fg-quick-slot]').replaceChildren(body);
      dialog.showModal();
      requestAnimationFrame(() => dialog.classList.add('is-open'));
      dialog.querySelector('input, button:not([data-fg-quick-close])')?.focus();
    } catch (e) {
      window.location.href = button.dataset.fgQuick;
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
})();
